const SendIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M20.25 3.75L10.5 13.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.25 3.75L14 20.25L10.5 13.5L3.75 10L20.25 3.75Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SendIcon;
